export const invoiceConstants = {
  SPINNER: "SPINNER",
  INVOICE_DATA: "INVOICE_DATA",
  INVOICE_DATA_NULL: "INVOICE_DATA_NULL",
};
